import {Component, inject, InjectionKey, Ref} from 'vue'
import {Emitter} from 'mitt';
import {KeyboardContext} from './composition/useKeyboard';
import {Apps} from './composition/use-apps';
import {WebSocketMessage} from "@/portal-websocket-client";
import {StateRoot} from "@/state";
import {PortalContext} from "@hantera/portal-app";

export const appsKey: InjectionKey<Apps> = Symbol('apps');

type Events = {
  keydown: {
    event: KeyboardEvent
    context: KeyboardContext
  }
  highlight: {
    type: string
    id: string
  },
};

export const mittKey: InjectionKey<Emitter<Events>> = Symbol('mitt');

export const phraseContextKey: InjectionKey<string> = Symbol('phraseContext');

export const webSocketSubscribeKey: InjectionKey<(handler: (message: WebSocketMessage) => void) => void> = Symbol('webSocketSubscribe');
export function webSocketSubscribe(handler: (message: WebSocketMessage) => void)
{
  const f = inject(webSocketSubscribeKey);
  if (!f) {
    throw new Error('webSocketSubscribe not supported in this context');
  }
  
  f(handler);
}
export const webSocketUnsubscribeKey: InjectionKey<(handler: (message: WebSocketMessage) => void) => void> = Symbol('webSocketUnsubscribe');
export function webSocketUnsubscribe(handler: (message: WebSocketMessage) => void)
{
  const f = inject(webSocketUnsubscribeKey);
  if (!f) {
    throw new Error('webSocketUnsubscribe not supported in this context');
  }

  f(handler);
}

export const stateContextKey: InjectionKey<StateRoot> = Symbol('stateContext');

export const defaultViewUriKey: InjectionKey<string> = Symbol('defaultViewUriKey');
/**
 * Contains a string used for constructing session-specific state keys for use in localStorage and sessionStorage.
 * 
 * For example, standalone portal host will pass a key based on the tenant and identity ID. Other hosts may use other
 * strategies, such as a state key per ticket id in case of Zendesk host.
 */
export const stateKey: InjectionKey<string> = Symbol('stateKey');

/**
 * If the component is rendered inside a workspace tab, this indicates§
 * whether the tab is currently selected (visible) or not.
 */
export const workspaceTabIsVisibleKey: InjectionKey<Ref<boolean>> = Symbol('workspaceTabIsVisible');

export const viewRepositoryKey: InjectionKey<{
  getView(context: PortalContext, path: string): Component | undefined
  registerView(path: string, component: Component, accessPatterns?: string[]): void 
}> = Symbol('viewRepositoryKey');